<script setup lang="ts">
  import { computed, defineProps, type PropType, toRef } from 'vue'
  import { type StoreGeneric } from 'pinia'
  import { TextField } from '@haskoning/vue-component-library'

  const props = defineProps({
    store: { type: Object as PropType<StoreGeneric>, required: true },
    stateName: { type: String, required: true },
    modelValue: { type: Boolean },
    disabledFields: { type: Array, required: false, default: () => [] }
  })

  const store = toRef(props, 'store')

  const vModel = computed({
    get: () => props.modelValue,
    set(value: boolean) {
      emit('update:modelValue', value)
    }
  })

  const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <v-form v-model="vModel">
    <slot name="prepend"></slot>
    <template v-for="field in store.fieldsFiltered">
      <v-select
        v-if="field.type === 'choice'"
        color="primary"
        :items="field.choices?.map((choice: any) => choice.display_name)"
        :label="field.label"
        v-model="store[stateName][field.parameter]"
        :rules="[
          (value: any) => !field.required || (value !== null && value !== undefined) || 'Required.'
        ]"
        :readonly="field.read_only"
        v-bind:key="'choice-' + field.parameter"
        :disabled="disabledFields.includes(field.parameter)"
      />
      <TextField
        v-else
        :field="field"
        v-bind:key="field.parameter"
        :model-value="store[stateName]"
        :disabled="disabledFields.includes(field.parameter)"
      />
    </template>
    <slot name="append"></slot>
  </v-form>
</template>
